export default __webpack_public_path__ + "static/media/new_upload.e575e27d.png";